import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { MatLegacyTabsModule as MatTabsModule } from "@angular/material/legacy-tabs";
import { TranslateModule } from "@ngx-translate/core";
import { LazyLoaderModule } from "@obg/common.lazy-loader";
import { MatCoreModule } from "@obg/mat.ui.core";
import { CoreModule } from "@obg/ngx.core";
import { CoreContentModule } from "@obg/ngx.core.content";
import { GlobalUiModule } from "@obg/ngx.ui.global";

import { LogoutCooldownModule } from "../../logout-cooldown/logout-cooldown.module";
import { SessionLimitModule } from "../../session-limit/session-limit.module";

import { ResponsibleGamingTabsContainer } from "./responsible-gaming-tabs.container";

const DIRECTIVES: any[] = [ResponsibleGamingTabsContainer];

@NgModule({
	imports: [
		CommonModule,
		MatTabsModule,
		LazyLoaderModule,
		MatCoreModule,
		CoreModule,
		CoreContentModule,
		GlobalUiModule,
		SessionLimitModule,
		LogoutCooldownModule,
		TranslateModule,
	],
	exports: DIRECTIVES,
	declarations: DIRECTIVES,
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ResponsibleGamingTabsModule {}
